import {useGetAndSet} from "./useGetAndSet";
import {createSetTrackingCategoryDataAction} from "../actions/dataActions";

export const useTrackingCategoryData = (params, dataFresh) => {
    return useGetAndSet("trackingcategory", params, createSetTrackingCategoryDataAction, dataFresh);
}